import Mapper from './Mapper'
import { Consultation } from '@web/store/types/modules/consultation'

/* istanbul ignore next */
export default class ConsultationMapper extends Mapper {
  static toClient (data): Consultation {
    return Mapper.toClient(data) as Consultation
  }
}
